module.exports = __webpack_public_path__ + "img/home_middle_desc.d6c9c0db.png";